import { SideBarLinkProps } from "@/types/types";
import { Link } from "react-router-dom";
import { useNotifications } from "@/context/NotificationContext";

const SidebarLink = ({ data, pathname, isExpanded }: SideBarLinkProps) => {
  const isActive = pathname === data.path || pathname.includes(data.path);
  const { totalUnreadNotifications } = useNotifications();
  const unreadCount = Number(totalUnreadNotifications) || 0;
  const isNotificationLink = data.id === "notification";

  const UnreadBadge = ({ compact = false }: { compact?: boolean }) => (
    <span
      className={`flex items-center justify-center rounded-full bg-[#FF6600] text-white font-semibold ${
        compact
          ? "absolute -right-2 -top-2 min-w-4 h-4 px-1 text-[10px]"
          : "min-w-5 h-5 px-1.5 text-[11px]"
      }`}
      aria-label={`${unreadCount} unread notifications`}
    >
      {unreadCount > 99 ? "99+" : unreadCount}
    </span>
  );

  return (
    <li className="h-[70px] md:h-[40px]" id={data.id}>
      <Link to={data.path}>
        <div
          className={`${
            isActive
              ? "md:bg-[#FEF4ED] md:border md:border-[#FFD6B9] md:rounded-[6px] text-[#FF6500]"
              : "text-[#62636C] bg-white border-none"
          }
           ${isExpanded ? "md:flex-row" : "md:flex-col"}
          px-3 py-2 flex h-full md:justify-start justify-center flex-col gap-x-2 w-full items-center md:items-start transform ease-in-out transition-all`}
        >
          <div className="relative w-[20px]">
            {data.icon}
            {isNotificationLink && unreadCount > 0 && !isExpanded && (
              <UnreadBadge compact />
            )}
          </div>
          {isExpanded && (
            <p
              className={`${
                isExpanded ? "opacity-100" : "w-[0px] opacity-0"
              }  whitespace-nowrap transform ease-in-out  transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%] flex gap-2.5 items-center`}
            >
              {data.label}
              {isNotificationLink && unreadCount > 0 && <UnreadBadge />}
              {/* {data.isNew && (
                <span className="text-[#004EC4] text-[11px] font-medium leading-4 px-2 py-[2px] border border-[#004EC44A] rounded-full">
                  New
                </span>
              )} */}
            </p>
          )}
          <p className="whitespace-nowrap font-medium text-xs mt-1 flex items-center gap-1 md:hidden">
            {data.label}
            {isNotificationLink && unreadCount > 0 && <UnreadBadge />}
          </p>
        </div>
      </Link>
    </li>
  );
};

export default SidebarLink;
